// extracted by mini-css-extract-plugin
export var typingIndicator = "_p2-0";